export const sucursalDeptoForSector = (motivos, formik) => {
  const attrName = formik.values.asignacion2 === 1 ? "DeptosucursalCasaCentral" : "DeptosucursalSucursales";
  const existentIds = [];
  return motivos
    ? motivos
        // Extraigo las sucursales y departamentos de los motivos
        .reduce((sucDeptos, motivo) => sucDeptos.concat(motivo[attrName]), [])
        // Filtro duplicados
        .filter((sucDepto) => {
          if (sucDepto === null || existentIds.includes(sucDepto.itemId)) {
            return false;
          }
          existentIds.push(sucDepto.itemId);
          return true;
        })
    : [];
};
